import checkJwt from "../../Global/jwtChecker";
import logout from "../../Global/logout";
import resolve from "../resolver";
import axios from "axios";

export default async function GetNewToken(clientUuid) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/token?clientUuid=' + clientUuid, {
            method: 'GET',
            headers: { 'Authorization' : unHashedJwt.data},
        }).then(
            res => (res)
        ).catch(error => error.response.data),
        "Admin"
    )
}